// extracted by mini-css-extract-plugin
export default {"facets":"VideoSearchFacets_facets__AeSWb"};